import React from 'react';
import { CampaignSkill } from 'models/CommonType';
import './SkillTags.css';

interface SkillTagsProps {
  skills?: CampaignSkill[];
  maxDisplayCount?: number;
}

const SkillTags: React.FC<SkillTagsProps> = ({ skills, maxDisplayCount = 10 }) => {
  if (!skills || skills.length === 0) {
    return null;
  }

  const displaySkills = skills.slice(0, maxDisplayCount);
  const hasMore = skills.length > maxDisplayCount;

  return (
    <div className="skill-tags-container">
      <div className="skill-tags-wrapper">
        {displaySkills.map((skill) => (
          <div key={skill.id} className="skill-tag">
            {skill.name}
          </div>
        ))}
        {hasMore && (
          <div className="skill-tag skill-tag-more">
            +{skills.length - maxDisplayCount}
          </div>
        )}
      </div>
    </div>
  );
};

export default SkillTags;